var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card-form',{attrs:{"title":"收款信息"}},[_c('qx-custom-form',{ref:"baseForm",attrs:{"noSubBtn":true,"formData":_vm.baseForm,"labelWidth":"120px"},scopedSlots:_vm._u([{key:"receiver",fn:function(prop){return _c('section',{},[_c('ChooseReceiver',{staticStyle:{"float":"left"},attrs:{"isRadio":true,"otherSearchData":{
          userType: _vm.userType,
        },"fnRadioDisabled":function (item) {
            var disabled = false;
            if (_vm.$route.query.loanType === '1') {
              if (item.userType !== Number(_vm.userType)) {
                disabled = true;
              }
            }
            return disabled;
          }},on:{"beforeSub":_vm.beforeSub,"change":_vm.handleReceiverChange},model:{value:(prop.form.receiver),callback:function ($$v) {_vm.$set(prop.form, "receiver", $$v)},expression:"prop.form.receiver"}}),_c('span',{staticClass:"error",staticStyle:{"margin-left":"16px"}},[(_vm.$route.query.loanType === '1')?_c('span',[_vm._v("收款人只能选择司机")]):_vm._e(),(
            _vm.$route.query.loanType === '2' || _vm.$route.query.loanType === '3'
          )?_c('span',[_vm._v("如果替代他人填报，则收款人请选择实际借款人！")]):_vm._e()])],1)}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }